const mapAssignedApproversToLevels = (assignedApprovers, isLevel) => {
  if (
    !assignedApprovers ||
    (Array.isArray(assignedApprovers) && !assignedApprovers.length)
  ) {
    return [];
  }

  const mapApprover = (approver) => {
    const user = approver?.user ?? {};
    const approverUser = approver?.approver_user ?? {};

    // The LOI payload carries the real names on approver_user; prefer those
    // over splitting a display name, which mis-derives initials for anyone
    // with a middle name.
    const firstName =
      user?.firstname ??
      approverUser?.firstname ??
      approverUser?.display_name?.split(' ')[0] ??
      '';
    const lastName =
      user?.lastname ??
      approverUser?.lastname ??
      approverUser?.display_name?.split(' ').slice(1).join(' ') ??
      '';
    const status = approver?.status ?? {};
    const workflow = approver?.approval_level_workflow ?? {};
    const meta = approver?.meta ?? {};

    return {
      id: approver?.id ? String(approver.id) : null,
      role_label:
        user?.account_role_label ??
        approver?.role_label ??
        // LOI approvers expose the role as an object on approver_user.
        approverUser?.account_role?.label ??
        null,
      // Order approvals nest these under `meta`; LOI approvals put them on the
      // approver itself.
      is_level_satisfied_by_higher_authority:
        meta?.is_level_satisfied_by_higher_authority ??
        approver?.is_level_satisfied_by_higher_authority,
      is_level_satisfied_by_self_approved:
        meta?.is_level_satisfied_by_self_approved ??
        approver?.is_level_satisfied_by_self_approved,
      is_satisfied_by_higher_authority:
        meta?.is_satisfied_by_higher_authority ??
        approver?.is_satisfied_by_higher_authority,
      is_satisfied_by_self_approved:
        meta?.is_satisfied_by_self_approved ??
        approver?.is_satisfied_by_self_approved,
      approver_user: {
        display_name:
          approverUser?.display_name ?? `${firstName} ${lastName}`.trim(),
        email: user?.email ?? approverUser?.email ?? null,
        initials: (
          (firstName?.[0] ?? '') + (lastName?.[0] ?? '')
        ).toUpperCase(),
      },
      status: {
        value: status?.label?.toLowerCase() ?? null,
        label: status?.label ?? null,
      },
      approval_requested_at:
        workflow?.created_at ?? approver?.created_at ?? null,
      actioned_at: approver?.updated_at ?? null,
    };
  };

  if (!isLevel && Array.isArray(assignedApprovers)) {
    return [
      {
        level_number: 1,
        status: assignedApprovers[0]?.status?.label?.toLowerCase() ?? null,
        rule: null,
        isLevel,
        approvers: assignedApprovers.map(mapApprover),
      },
    ];
  }

  if (typeof assignedApprovers !== 'object') return [];

  return Object.values(assignedApprovers).map((level) => ({
    level_number: level?.level ?? null,
    status: level?.status ?? null,
    rule: level?.rule ?? null,
    isLevel,
    approvers: Array.isArray(level?.approvers)
      ? level.approvers.map(mapApprover)
      : [],
  }));
};

export default mapAssignedApproversToLevels;
